import { getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";

export const getUserRights = (user_id, child_uid, onCompleteFunc) => {
    let url = '';

    url = Globals.APIFolder + '/rights/' + user_id + '/user?comms_app=true';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};

// Updates the user's rights
export const updateUserRights = (user_id,formData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/rights/' + user_id + '/user';

    getDataWithPromise(url, 'post', {formData: formData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
}